import React from 'react'

import { Form, CheckboxProps } from 'semantic-ui-react'
import { Typography, Box, Card, CardContent } from '@mui/material'

import CustomLabel from '../../../components/common/custom-label/CustomLabel'

import { IProject } from '../../../api/Data'
import { UserContext } from '../../../contexts/UserContext'

const SettingsCard = (props: IProps) => {
  // Props
  const { project, handleChange } = props
  const { userProfile } = React.useContext(UserContext)

  const { name, shouldEmailEverySubmission } = project

  const handleCheckboxChange = (e: React.MouseEvent<HTMLInputElement, MouseEvent>, data: CheckboxProps) => {
    const { name, checked } = data

    handleChange(e, {
      name: String(name),
      checked: Boolean(checked),
    })
  }

  return (
    <Card sx={{ width: '100%', boxSizing: 'border-box', height: '100%' }}>
      <CardContent>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="h5" fontWeight="bold">
            Notification Settings
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Vloggi sends key project email updates by default. Turn this on only if you want an email for every
            submission.
          </Typography>
          <Box sx={{ backgroundColor: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 1, padding: 1.5 }}>
            <Typography variant="caption" color="textSecondary" display="block">
              Notifications will be sent to
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {userProfile?.email || 'the team administrator'}
            </Typography>
          </Box>
          <Typography variant="h6" fontWeight="bold">
            Submission Notification Frequency
          </Typography>
          <Form>
            <Form.Field>
              <CustomLabel>
                <CustomLabel.Text text="Every Submission" />
                <CustomLabel.Popup popupContent={`Notify when ${name} receives a submission`} />
                <CustomLabel.Checkbox
                  name="shouldEmailEverySubmission"
                  checked={shouldEmailEverySubmission}
                  onClick={handleCheckboxChange}
                />
              </CustomLabel>
            </Form.Field>
          </Form>
        </Box>
      </CardContent>
    </Card>
  )
}

interface IProps {
  project: IProject
  handleChange: (arg: React.SyntheticEvent, { name, checked }: { name: string; checked: boolean }) => void
}

export default SettingsCard
